import {useEffect, useRef} from 'react';

import CSS from './PopupBanner.module.scss';
import Vector from '@/components/elements/vector/Vector';
import Description from './Description';
import {temporalStyle} from '@/lib/utils';
import type {Notification} from '@/types/api/notifications';

export default function PopupBanner({
  notification,
  setAsSeen,
  setNotificationsOpen
}: {
  notification: Notification;
  setAsSeen: () => void;
  setNotificationsOpen: (
    isSystem: Notification['isSystem'],
    id: Notification['_id']
  ) => void;
}) {
  const ref = useRef<HTMLElement>(null);
  const timerId = useRef<number>(null);

  // Closing the popup after a delay
  useEffect(() => {
    timerId.current = window.setTimeout(onClose, 5e3);
    return () => window.clearTimeout(timerId.current!);
  }, [notification]); // eslint-disable-line react-hooks/exhaustive-deps

  function onClick() {
    onClose();
    setNotificationsOpen(notification.isSystem, notification._id);
  }

  function onClose() {
    temporalStyle(ref, CSS.hide, 1e3, setAsSeen);
  }

  return (
    <section
      ref={ref}
      className={[
        CSS.popupBanner,
        notification.priority === 'HIGH' ? CSS.important : ''
      ].join(' ')}>
      <div>
        <h6>{notification.title}:</h6>
        <Description notification={notification} className={CSS.description} />
      </div>
      <div>
        <Vector name="FiEye" className={CSS.icon} onClick={onClick} hasFocus />
        <Vector
          name="IoClose"
          className={CSS.icon}
          onClick={onClose}
          hasFocus
        />
      </div>
    </section>
  );
}
